import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ComingSoon } from "@/components/ui/coming-soon";
import { MobilePageTitle } from "@/components/ui/mobile-page-title";
import { ScrollableContainer } from "@/components/ui/scrollbar";

export const Route = createFileRoute("/(protected)/dashboard/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <ScrollableContainer>
      <div className="flex h-full flex-col">
        <MobilePageTitle className="mt-5 mb-4 px-6">
          {t("pages:dashboard.sidebar.dashboard")}
        </MobilePageTitle>
        <ComingSoon
          title={t("pages:dashboard.comingSoon.title")}
          description={t("pages:dashboard.comingSoon.description")}
        />
      </div>
    </ScrollableContainer>
  );
}
